import type { BoardSlugRename } from "./index"

export const BOARD_SLUG_RENAMES: readonly BoardSlugRename[] = Object.freeze([
  Object.freeze({ from: "moge", to: "aimg" }),
  Object.freeze({ from: "nfl", to: "fb", displayName: "アメフト" }),
])
